import {Injectable} from '@angular/core';

import {FeedPriceTypesEnum, MarketDataFeedDisplayPriceInterface, MarketDataPriceListInterface, SesHelper} from '@spa/api';
import {SesPermissionService} from './ses-permission.service';

@Injectable({
    providedIn: 'root'
})
export class SesPriceService {

    constructor(private readonly sesPermissionService: SesPermissionService) {
    }

    public getPriceByTypeAndPermission(priceList: MarketDataPriceListInterface[], priceType: FeedPriceTypesEnum, includeCurrency: boolean = true) {
        if (!this.sesPermissionService.hasViewFeedPricePermission()) {
            priceList = null;
        }

        return SesHelper.getPriceDataBy(priceList, priceType, includeCurrency);
    } 
    
}
